import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-flight-secondary-data',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './flight-secondary-data.component.html',
  styleUrl: './flight-secondary-data.component.scss'
})
export class FlightSecondaryDataComponent {
  @Input() label: string = '';
  @Input() value: string = null;
}
